import { API } from "@/lib/api";

function readCookie(name) {
  const m = document.cookie.match(new RegExp("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)"));
  return m ? decodeURIComponent(m.pop()) : "";
}

/**
 * Stream a Generative Workspace from the Adaptive OS backend (AG-UI style SSE).
 * Reads text/event-stream over fetch and invokes onEvent for each decoded event.
 */
export async function streamWorkspace({ prompt, goalId, onEvent, signal }) {
  const csrf = readCookie("csrf_token");
  const res = await fetch(`${API}/adaptive/stream`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(csrf ? { "X-CSRF-Token": csrf } : {}),
    },
    body: JSON.stringify({ prompt, goal_id: goalId || null }),
    credentials: "include",
    signal,
  });

  if (!res.ok || !res.body) {
    throw new Error(`Stream failed (${res.status})`);
  }

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split("\n\n");
    buffer = parts.pop() || "";
    for (const part of parts) {
      const line = part.split("\n").find((l) => l.startsWith("data: "));
      if (!line) continue;
      try {
        onEvent(JSON.parse(line.slice(6)));
      } catch (err) {
        void err; /* skip malformed SSE chunk */
      }
    }
  }
}
